import React, { useEffect } from 'react'
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ValidationText from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';
import { Separator } from '../../utils/utils';

// Viewer Component for Displaying the Checklist
const MultiChoice = ({ item, setItem, activeAccordion, validations }) => {
    // let activeAccordion = 'Intake Form';
    console.log("activeAccordion", activeAccordion)
    // Parse options from item.content (split by new lines)
    const { handleSelectMultipleOptionsCheckList, handleViewerHintTextChange } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const options = item.options ? item.options.split(Separator) : [];

    useEffect(() => {
        const existingSelectedOptions = item.selectedOptions?.split(Separator) || [];
        const currentSelected = existingSelectedOptions.map((option) => option.split('(D)')[0]);

        if (JSON.stringify(currentSelected) === JSON.stringify(options)) return;

        setItem((prev) =>
            prev.map((section) => {
                if (section.key === activeAccordion) {
                    const updatedItems = section.items.map((currItem) => {
                        if (currItem.ItemID === item.ItemID) {
                            const list = options.join(Separator);
                            return { ...currItem, selectedOptions: list };
                        }
                        return currItem;
                    });
                    return { ...section, items: updatedItems };
                }
                return section;
            })
        );
    }, []);

    // Parse all options with TR/hintText metadata
    const selectedOptions =
        (item.selectedOptions?.split(Separator) || []).length > 0
            ? (item.selectedOptions.split(Separator) || []).map((optStr) => {
                const hasSelected = optStr.includes('(D)');
                const baseLabel = optStr.split('(D)')[0].split('[')[0];

                const metaMatch = optStr.match(/\[(.*?)\]/);
                let textResponse = 'false';
                let hintText = '';
                let value = "";

                if (metaMatch) {
                    const parts = metaMatch[1].split('|');
                    parts.forEach((p) => {
                        if (p.startsWith('TR=')) textResponse = p.split('=')[1];
                        if (p.startsWith("hintText=")) hintText = p.split('=')[1].replace(/'/g, '');
                        if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                    });
                }

                return {
                    content: baseLabel,
                    checked: hasSelected,
                    textResponse,
                    hintText,
                    value: value
                };
            })
            : [];

    return (
        <div className='content-box d-flex gap-10'>
            <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end ${validations?.isInvalid ? 'Denied-clr' : ''}`} >
                {item.content || '[Insert prompt or question]'}
                {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
            </p>

            <div className="d-flex flex-column gap-6 w-100">
                <div className='d-flex gap-16 row-gap-6 flex-wrap'>
                    {selectedOptions.length > 0 &&
                        selectedOptions.map((option, index) => (
                            <React.Fragment key={index}>

                                <div className={`d-flex flex-column gap-6 ${option.checked && option.textResponse === "true" ? 'w-100' : ''}`}>
                                    <label className="custom_check_box d-flex gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input mt-3px"
                                            id={`checklist-${index}-${item.ItemID}`}
                                            checked={option.checked}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                handleSelectMultipleOptionsCheckList(item, index);
                                            }}
                                        // disabled
                                        />
                                        <p
                                            className="text text-black"
                                            htmlFor={`checklist-${index}-${item.ItemID}`}
                                        >
                                            {option.content || '[Insert Option]'}
                                        </p>
                                    </label>

                                    {option.checked && option.textResponse === 'true' && (
                                        <div className={`input w-100 ${validations?.optionValidations?.[index] ? 'error' : ''}`}>
                                            <input
                                                type="text"
                                                className='form-control height-30'
                                                id='value'
                                                name='value'
                                                value={option?.value || ''}
                                                placeholder={option.hintText}
                                                // onChange={handleChangeHintText}
                                                onChange={e => handleViewerHintTextChange(e, item, index)}
                                            />
                                            <ValidationText  name={'Option'} validations={validations}/>
                                        </div>
                                    )}

                                </div>

                            </React.Fragment>
                        ))}
                </div>


            </div>

        </div >
    );
};

export default MultiChoice;